function calculateMiddlewareUrl({
  options,
  headers
}) {
  const { apiUrl, ssrApiUrl } = options.middleware;
  if (typeof window !== "undefined") {
    if (options.multistore?.enabled) {
      const url2 = new URL(apiUrl);
      url2.host = window.location.host;
      return url2.href;
    }
    return apiUrl;
  }
  if (ssrApiUrl) {
    return ssrApiUrl;
  }
  if (!options.multistore?.enabled) {
    return apiUrl;
  }
  const forwardedHost = headers["x-forwarded-host"] ?? headers.host;
  const url = new URL(apiUrl);
  url.host = forwardedHost && [...forwardedHost].join("") || new URL(apiUrl).host;
  return url.href;
}
function removeTrailingSlash(url) {
  return url.replace(/\/$/, "");
}
export function composeMiddlewareUrl({
  options,
  headers
}) {
  const url = calculateMiddlewareUrl({ options, headers });
  return removeTrailingSlash(url);
}
